import React, { useCallback } from "react";
import { Paths } from "../../../../Paths";
import { ArrowLineIcon } from "../icons/ArrowLineIcon";
import { useLocation, useNavigate } from "react-router-dom";

export const BackLink = React.memo(function BackLink(props: Props) {
    const { position } = props;

    const navigate = useNavigate();

    const location = useLocation();

    const handleListClicked = useCallback(() => {
        const from = location.state && location.state.from;
        // 遷移元がお知らせ一覧(/information/list/\d)であればそのまま戻る
        if (from && from.match(/information\/list\/\d/)) {
            navigate(-1);
        } else {
            navigate(`${Paths.information}${Paths.list}`);
        }
    }, [location, history]);

    return (
        <div className={`link_area_${position}`}>
            <div className="link_area" onClick={handleListClicked}>
                <ArrowLineIcon />
                <p className="text">一覧へ戻る</p>
            </div>
        </div>
    );
});

type Props = {
    position: "left" | "center"
};
